export default function reducer(state = {
    test: {
        start_time: null,
        end_time: null,
        avg_response_time: null,
        answers: null,
        json_text: null
    },
    step: 1,
    score: null,
    baseline_score: null,
    base: false,
    voluntary: false,
    set_base: true,
    cas_score: null
}, action) {
    switch (action.type) {
        case "STORE_BASELINE_ONE": {
            return {
                ...state,
                test: action.baseline,
                step: action.step
            }
        }
        case "STORE_BASELINE_SCORE": {
            return {
                ...state,
                score: action.score,
                baseline_score: action.baseline_score,
                base: false,
                step: 1,
                set_base: action.step == 2 ? true : false
            }
        }
        case "CLEAR_BASELINE_SCORE": {
            return {
                ...state,
                test: {
                    start_time: null,
                    end_time: null,
                    avg_response_time: null,
                    answers: null,
                    json_text: null
                },
                step: 1,
                score: null
            }
        }
        case "CLEAR_USER": {
            return {
                ...state,
                test: {
                    start_time: null,
                    end_time: null,
                    avg_response_time: null,
                    answers: null,
                    json_text: null
                },
                step: 1,
                score: null,
                baseline_score: null,
                base: false,
                voluntary: false
            }
        }
        case "STORE_REGISTER_DETAILS": {
            return {
                ...state,
                base: true
            }
        }
        case "STORE_ACCESS_TOKEN": {
            return {
                ...state,
                base: !action.baseline,
                step: 1
            }
        }
        case "STORE_DASHBOARD_DATA": {
            return {
                ...state,
                voluntary: action.data.voluntary_test !== undefined ? action.data.voluntary_test : false
            }
        }
        case "STORE_CAS_SCORE": {
            return {
                ...state,
                cas_score: action.score
            }
        }
        case "CLEAR_BASELINE_STATE": {
            return {
                ...state,
                test: {
                    start_time: null,
                    end_time: null,
                    avg_response_time: null,
                    answers: null,
                    json_text: null
                },
                step: 1,
                score: null,
                baseline_score: null,
                base: false,
                voluntary: false
            }
        }
        default:
            break;
    }
    return state;
}
